<template>
    <div class="w-full">
        <!-- Option A: Internal Route Link -->
        <router-link
            v-if="item.to"
            :to="item.to"
            class="flex items-center justify-between px-3 py-2 text-sm font-medium text-slate-700 dark:text-slate-300 rounded-md hover:bg-slate-200 dark:hover:bg-slate-800 hover:text-slate-950 dark:hover:text-white transition-colors"
            active-class="!bg-blue-600 !text-white hover:!bg-blue-600 dark:hover:!bg-blue-600"
            :title="isCollapsed ? item.label : ''"
        >
            <div class="flex items-center space-x-2.5">
                <i v-if="item.icon" :class="[item.icon, item.class]" class="text-base shrink-0"></i>
                <span v-show="!isCollapsed" class="truncate">{{ item.label }}</span>
            </div>
        </router-link>
        
        <!-- Option B: External URL Link -->
        <a
            v-else-if="item.url"
            :href="item.url"
            :target="item.target || '_blank'"
            class="flex items-center justify-between px-3 py-2 text-sm font-medium text-slate-700 dark:text-slate-300 rounded-md hover:bg-slate-200 dark:hover:bg-slate-800 hover:text-slate-950 dark:hover:text-white transition-colors"
            :title="isCollapsed ? item.label : ''"
        >
            <div class="flex items-center space-x-2.5">
                <i v-if="item.icon" :class="[item.icon, item.class]" class="text-base shrink-0"></i>
                <span v-show="!isCollapsed" class="truncate">{{ item.label }}</span>
            </div>
            <i v-show="!isCollapsed" class="pi pi-external-link text-xs text-slate-400 dark:text-slate-500"></i>
        </a>
  
        <!-- Option C: Submenu Parent (Collapsible) -->
        <div v-else-if="item.items && item.items.length">
            <button
                @click="isOpen = !isOpen"
                class="w-full flex items-center justify-between px-3 py-2 text-sm font-medium text-slate-700 dark:text-slate-300 rounded-md hover:bg-slate-200 dark:hover:bg-slate-800 hover:text-slate-950 dark:hover:text-white transition-colors cursor-pointer"
                :title="isCollapsed ? item.label : ''"
            >
                <div class="flex items-center space-x-2.5">
                    <i v-if="item.icon" :class="[item.icon, item.class]" class="text-base shrink-0"></i>
                    <span v-show="!isCollapsed" class="truncate">{{ item.label }}</span>
                </div>
                <i
                    v-show="!isCollapsed"
                    class="pi pi-chevron-down text-xs text-slate-500 dark:text-slate-400 transition-transform duration-200"
                    :class="{ 'rotate-180': isOpen }"
                ></i>
            </button>
  
            <!-- Nested Submenu Children (Hidden when collapsed) -->
            <div v-show="isOpen && !isCollapsed" class="ml-4 pl-2 border-l border-slate-200 dark:border-slate-800 space-y-1 mt-1">
                <MenuItem
                    v-for="(child, idx) in item.items"
                    :key="idx"
                    :item="child"
                    :is-collapsed="isCollapsed"
                />
            </div>
        </div>
  
        <!-- Option D: Static Menu Label -->
        <div 
            v-else 
            class="px-3 py-2 text-sm font-semibold text-slate-500 dark:text-slate-400 flex items-center space-x-2.5"
            :title="isCollapsed ? item.label : ''"
        >
            <i v-if="item.icon" :class="[item.icon, item.class]" class="text-base shrink-0"></i>
            <span v-show="!isCollapsed" class="truncate">{{ item.label }}</span>
        </div>
    </div>
</template>
  
<script setup>
    import { ref } from 'vue'
    
    defineProps({
        item: {
            type: Object,
            required: true
        },
        isCollapsed: {
            type: Boolean,
            default: false
        }
    })
    
    const isOpen = ref(false)
</script>